// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"766":"c1b922fe","778":"049fb7cc"}[chunkId] + ".chunk.js";
};